/**
 * @param {object} state
 * @param {string} timezone
 */
const setProfileTimezone = (state, timezone) => {
  state.timezone = timezone
}

/**
 * @param {object}      state
 * @param {object}      preferences
 * @param {number|null} preferences.team         - The preferred team ID, or null for all teams.
 * @param {string|null} preferences.library_type - The preferred library type (e.g. "fabric").
 */
const setLandingPagePreferences = (state, preferences) => {
  state.landingPagePreferences = preferences
}

export default {
  setProfileTimezone,
  setLandingPagePreferences
}
